export default __webpack_public_path__ + "static/media/fcv-costofownership.b8180831.svg";